var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 1.16675C10.276 1.16675 10.4998 1.39061 10.4998 1.66675V13.793L13.813 10.4799C14.0082 10.2846 14.3248 10.2846 14.5201 10.4799C14.7153 10.6751 14.7153 10.9917 14.5201 11.187L10.3534 15.3536C10.1581 15.5489 9.84155 15.5489 9.64628 15.3536L5.47962 11.187C5.28435 10.9917 5.28436 10.6751 5.47962 10.4799C5.67488 10.2846 5.99146 10.2846 6.18672 10.4799L9.49984 13.793V1.66675C9.49984 1.39061 9.72369 1.16675 9.99984 1.16675ZM2.1665 15.0001C2.1665 14.7239 1.94265 14.5001 1.6665 14.5001C1.39036 14.5001 1.1665 14.7239 1.1665 15.0001V18.3334C1.1665 18.6096 1.39036 18.8334 1.6665 18.8334H18.3332C18.6093 18.8334 18.8332 18.6096 18.8332 18.3334V15.0001C18.8332 14.7239 18.6093 14.5001 18.3332 14.5001C18.057 14.5001 17.8332 14.7239 17.8332 15.0001V17.8334H2.1665V15.0001Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.44bc43eede676598d09d81e83703d075.svg";
export { ForwardRef as ReactComponent };